var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMainLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4483 3.14399V3.13599H24.0403H24.0323H24.0243H16.1363V3.14399H10.0003C8.52031 3.14399 7.32031 4.34399 7.32031 5.81599V33.68C7.32031 35.16 8.52031 36.352 10.0003 36.352H16.0083C17.3763 36.352 18.4803 35.248 18.4803 33.88V29.288C18.5763 28.456 19.2003 26.6 22.9523 26.632C23.3043 26.664 23.6643 26.68 24.0243 26.68C30.5283 26.68 35.7203 21.408 35.8003 14.904C35.8803 7.75999 30.7603 3.86399 24.4483 3.14399Z",
    fill: "#0073AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8639 8.69599C10.8639 8.69599 12.7039 3.14399 20.3839 4.69599C28.0639 6.24799 32.5599 7.87999 33.1839 15.048C33.9199 23.448 22.3039 24.88 20.1359 24.88C17.9679 24.88 15.0719 29.456 14.3759 30.928C13.6799 32.4 11.2719 35.624 9.39189 31.744C7.51189 27.864 9.67989 10.048 10.8639 8.69599Z",
    fill: "#40A99E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9357 7.40001C14.1517 7.98401 12.7197 9.34401 12.0317 11.096C11.0317 13.624 9.41572 18.784 10.8637 22.96C12.8637 28.72 15.8077 23.168 17.5197 22.344C19.2317 21.52 21.0317 21.2 24.3037 21.2C27.5757 21.2 33.4157 17.44 30.4317 12.336C27.4477 7.23201 18.6237 6.57601 16.0957 7.35201C16.0397 7.36801 15.9837 7.38401 15.9357 7.40001Z",
    fill: "#FFEF60"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6316 11.024C25.6316 11.024 20.2956 7.86402 16.8316 10.728C13.3676 13.592 15.4156 19.632 20.5916 19.664C25.7676 19.696 28.0556 16.944 28.3276 15.28C28.6076 13.608 27.4316 12.144 25.6316 11.024Z",
    fill: "#D97E3F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7603 11.92C21.7603 11.92 19.4803 11.416 18.2163 13.008C16.9523 14.6 17.5043 18.032 21.3203 17.544C25.1363 17.056 26.1523 15.28 24.8563 13.4C24.0483 12.232 21.7603 11.92 21.7603 11.92Z",
    fill: "#C73734"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogo);
export default __webpack_public_path__ + "static/media/main-logo.2cb8f21c749092de1e1c455ee925ad8a.svg";
export { ForwardRef as ReactComponent };